function createCommonjsModule(e, n) {
  return e(n = {
    exports: {}
  }, n.exports), n.exports;
}

var base64 = createCommonjsModule(function (e, n) {
  !function () {
    var e = n,
        r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    function t(e) {
      this.message = e;
    }

    t.prototype = new Error(), t.prototype.name = "InvalidCharacterError", e.btoa || (e.btoa = function (e) {
      for (var n, o, a = String(e), i = 0, s = r, c = ""; a.charAt(0 | i) || (s = "=", i % 1); c += s.charAt(63 & n >> 8 - i % 1 * 8)) {
        if ((o = a.charCodeAt(i += .75)) > 255) throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
        n = n << 8 | o;
      }

      return c;
    }), e.atob || (e.atob = function (e) {
      var n = String(e).replace(/[=]+$/, "");
      if (n.length % 4 == 1) throw new t("'atob' failed: The string to be decoded is not correctly encoded.");

      for (var o, a, i = 0, s = 0, c = ""; a = n.charAt(s++); ~a && (o = i % 4 ? 64 * o + a : a, i++ % 4) ? c += String.fromCharCode(255 & o >> (-2 * i & 6)) : 0) {
        a = r.indexOf(a);
      }

      return c;
    });
  }();
});

function btoa(e) {
  return base64.btoa(unescape(encodeURIComponent(e)));
}

function base64URLEncode(e) {
  return btoa(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

function clone(e) {
  return JSON.parse(JSON.stringify(e));
}

function onNextTick(e) {
  setTimeout(e, 0);
}

function wrapPromiseCallback(e, n) {
  return e.then(function (e) {
    return n && setTimeout(function () {
      n(null, e);
    }, 0), e;
  }, function (e) {
    return n && setTimeout(function () {
      n(e, null);
    }, 0), Promise.reject(e);
  });
}

function transformValuesToVersionedValues(e) {
  var n = {};

  for (var r in e) {
    e.hasOwnProperty(r) && (n[r] = {
      value: e[r],
      version: 0
    });
  }

  return n;
}

function transformValuesToUnversionedValues(e) {
  var n = {};

  for (var r in e) {
    e.hasOwnProperty(r) && (n[r] = e[r].value);
  }

  return n;
}

function chunkUserEventsForUrl(e, n) {
  for (var r = n.slice(0), t = [], o = e, a = void 0; r.length > 0;) {
    for (a = []; o > 0;) {
      var i = r.pop();
      if (!i) break;
      (o -= base64URLEncode(JSON.stringify(i)).length) < 0 && a.length > 0 ? r.push(i) : a.push(i);
    }

    o = e, t.push(a);
  }

  return t;
}

var MAX_URL_LENGTH = 2e3;

function sendEvents(e, n, r) {
  var t = e + "?d=" + base64URLEncode(JSON.stringify(n)),
      o = function o(e) {
    var n = new XMLHttpRequest();
    if ("withCredentials" in n) n.open("GET", t, !r), r || n.addEventListener("load", e), n.send();else {
      var o = new Image();
      r || o.addEventListener("load", e), o.src = t;
    }
  };

  if (!r) return new Promise(function (e) {
    o(e);
  });
  o();
}

function EventProcessor(e, n) {
  var r = {},
      t = [],
      o = !0;
  return r.enqueue = function (e) {
    t.push(e);
  }, r.flush = function (r, a) {
    var i = void 0 !== a && a,
        s = n.serializeEvents(t);
    if (!r) return o && console && console.warn && console.warn("Be sure to call `identify` in the LaunchDarkly client: http://docs.launchdarkly.com/docs/running-an-ab-test#include-the-client-side-snippet"), Promise.resolve();
    if (o = !1, 0 === s.length) return Promise.resolve();

    for (var c = chunkUserEventsForUrl(MAX_URL_LENGTH - e.length, s), u = [], l = 0; l < c.length; l++) {
      u.push(sendEvents(e, c[l], i));
    }

    return t = [], a ? Promise.resolve() : Promise.all(u);
  }, r;
}

function EventEmitter() {
  var e = {},
      n = {};
  return e.on = function (e, r, t) {
    n[e] = n[e] || [], n[e] = n[e].concat({
      handler: r,
      context: t
    });
  }, e.off = function (e, r, t) {
    if (n[e]) for (var o = 0; o < n[e].length; o++) {
      n[e][o].handler === r && n[e][o].context === t && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
    }
  }, e.emit = function (e) {
    if (n[e]) for (var r = 0; r < n[e].length; r++) {
      n[e][r].handler.apply(n[e][r].context, Array.prototype.slice.call(arguments, 1));
    }
  }, e.maybeReportError = function (e) {
    e && (n["error"] ? this.emit("error", e) : console.error(e.message));
  }, e;
}

function _toConsumableArray(e) {
  if (Array.isArray(e)) {
    for (var n = 0, r = Array(e.length); n < e.length; n++) {
      r[n] = e[n];
    }

    return r;
  }

  return Array.from(e);
}

function _defineProperty(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function EventSerializer(e) {
  var n = {},
      r = e.all_attributes_private,
      t = e.private_attribute_names || [],
      o = {
    key: !0,
    custom: !0,
    anonymous: !0
  },
      a = {
    key: !0,
    secondary: !0,
    ip: !0,
    country: !0,
    email: !0,
    firstName: !0,
    lastName: !0,
    avatar: !0,
    name: !0,
    anonymous: !0,
    custom: !0
  };

  function i(e) {
    return Object.keys(e).map(function (n) {
      return [n, "user" === n ? function (e) {
        var n = e.privateAttributeNames || [],
            i = function i(e, a) {
          return Object.keys(e).reduce(function (i, s) {
            var c = [].concat(_toConsumableArray(i));
            return a(s) && (!function (e) {
              return !o[e] && (r || -1 !== n.indexOf(e) || -1 !== t.indexOf(e));
            }(s) ? c[0][s] = e[s] : c[1][s] = !0), i;
          }, [{}, {}]);
        },
            s = i(e, function (e) {
          return a[e];
        }),
            c = s[0],
            u = s[1];

        if (e.custom) {
          var l = i(e.custom, function () {
            return !0;
          });
          c.custom = l[0], Object.assign(u, l[1]);
        }

        var f = Object.keys(u);
        f.length && (f.sort(), c.privateAttrs = f);
        return c;
      }(e[n]) : e[n]];
    }).reduce(function (e, n) {
      return Object.assign({}, e, _defineProperty({}, n[0], n[1]));
    }, {});
  }

  return n.serializeEvents = function (e) {
    return e.map(i);
  }, n;
}

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g,
    escapeStringRegexp = function escapeStringRegexp(e) {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(matchOperatorsRe, "\\$&");
};

function doesUrlMatch(e, n, r, t) {
  var o = n.replace(r, "").replace(t, ""),
      a = void 0,
      i = void 0;

  switch (e.kind) {
    case "exact":
      i = n, a = new RegExp("^" + escapeStringRegexp(e.url) + "/?$");
      break;

    case "canonical":
      i = o, a = new RegExp("^" + escapeStringRegexp(e.url) + "/?$");
      break;

    case "substring":
      i = o, a = new RegExp(".*" + escapeStringRegexp(e.substring) + ".*$");
      break;

    case "regex":
      i = o, a = new RegExp(e.pattern);
      break;

    default:
      return !1;
  }

  return a.test(i);
}

function findGoalsForClick(e, n) {
  for (var r = [], t = 0; t < n.length; t++) {
    for (var o = e.target, a = n[t], i = a.selector, s = document.querySelectorAll(i); o && s.length > 0;) {
      for (var c = 0; c < s.length; c++) {
        o === s[c] && r.push(a);
      }

      o = o.parentNode;
    }
  }

  return r;
}

function GoalTracker(e, n) {
  for (var r = {}, t = null, o = [], a = 0; a < e.length; a++) {
    for (var i = e[a], s = i.urls || [], c = 0; c < s.length; c++) {
      if (doesUrlMatch(s[c], location.href, location.search, location.hash)) {
        "pageview" === i.kind ? n("pageview", i) : (o.push(i), n("click_pageview", i));
        break;
      }
    }
  }

  return o.length > 0 && (t = function t(e) {
    for (var r = findGoalsForClick(e, o), t = 0; t < r.length; t++) {
      n("click", r[t]);
    }
  }, document.addEventListener("click", t)), r.dispose = function () {
    document.removeEventListener("click", t);
  }, r;
}

function Stream(e, n, r, t) {
  var o = {},
      a = e + "/eval/" + n + "/",
      i = null;
  return o.connect = function (o, s) {
    if ("undefined" != typeof EventSource) {
      var c = void 0;

      for (var u in t ? c = e + "/ping/" + n : (c = a + base64URLEncode(JSON.stringify(o)), null != r && (c = c + "?h=" + r)), i = new window.EventSource(c), s) {
        s.hasOwnProperty(u) && i.addEventListener(u, s[u]);
      }
    }
  }, o.disconnect = function () {
    i && i.close();
  }, o.isConnected = function () {
    return i && (i.readyState === EventSource.OPEN || i.readyState === EventSource.CONNECTING);
  }, o;
}

function createCustomError(e) {
  function n(e, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = n;
  }

  return n.prototype = new Error(), n.prototype.name = e, n.prototype.constructor = n, n;
}

var LDUnexpectedResponseError = createCustomError("LaunchDarklyUnexpectedResponseError"),
    LDInvalidEnvironmentIdError = createCustomError("LaunchDarklyInvalidEnvironmentIdError"),
    LDInvalidUserError = createCustomError("LaunchDarklyInvalidUserError"),
    LDInvalidEventKeyError = createCustomError("LaunchDarklyInvalidEventKeyError"),
    LDInvalidArgumentError = createCustomError("LaunchDarklyInvalidArgumentError"),
    LDFlagFetchError = createCustomError("LaunchDarklyFlagFetchError"),
    docLink = " Please see https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client for instructions on SDK initialization.",
    localStorageUnavailable = function localStorageUnavailable() {
  return "localStorage is unavailable";
},
    unknownCustomEventKey = function unknownCustomEventKey(e) {
  return 'Custom event "' + e + '" does not exist';
},
    environmentNotFound = function environmentNotFound() {
  return "environment not found." + docLink;
},
    environmentNotSpecified = function environmentNotSpecified() {
  return "No environment specified." + docLink;
},
    errorFetchingFlags = function errorFetchingFlags(e) {
  return "Error fetching flag settings: " + (e.message || e);
},
    userNotSpecified = function userNotSpecified() {
  return "No user specified." + docLink;
},
    invalidUser = function invalidUser() {
  return "Invalid user specified." + docLink;
},
    json = "application/json";

function fetchJSON(e, n, r) {
  var t = new XMLHttpRequest();
  return t.addEventListener("load", function () {
    200 === t.status && t.getResponseHeader("Content-type") && t.getResponseHeader("Content-Type").startsWith(json) ? r(null, JSON.parse(t.responseText)) : r(t.statusText);
  }), t.addEventListener("error", function () {
    404 === t.status && r(new LDInvalidEnvironmentIdError(environmentNotFound())), r(t.statusText);
  }), n ? (t.open("REPORT", e), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(n))) : (t.open("GET", e), t.send()), t;
}

function Requestor(e, n, r) {
  var t = void 0,
      o = void 0,
      a = {
    fetchFlagSettings: function fetchFlagSettings(a, i, s) {
      var c = void 0,
          u = void 0,
          l = void 0,
          f = void 0;
      r ? (u = [e, "/sdk/eval/", n, "/user", i ? "?h=" + i : ""].join(""), l = a) : (c = base64URLEncode(JSON.stringify(a)), u = [e, "/sdk/eval/", n, "/users/", c, i ? "?h=" + i : ""].join(""));
      var v,
          d,
          p = (v = s, function (e, n) {
        var r = n;
        n && (r = transformValuesToVersionedValues(n)), v(e, r), t = null, o = null;
      });
      t ? (t.abort(), d = o, f = function f() {
        d && d.apply(null, arguments), p.apply(null, arguments);
      }) : f = p, o = f, t = fetchJSON(u, l, f);
    },
    fetchGoals: function fetchGoals(r) {
      fetchJSON([e, "/sdk/goals/", n].join(""), null, r);
    }
  };
  return a;
}

function sanitizeUser(e) {
  var n = clone(e);
  return n.key && (n.key = n.key.toString()), n;
}

function Identity(e, n) {
  var r = {},
      t = void 0;
  return r.setUser = function (e) {
    t = sanitizeUser(e), n(clone(t));
  }, r.getUser = function () {
    return clone(t);
  }, e && r.setUser(e), r;
}

function get(e) {
  try {
    return localStorage.getItem(e);
  } catch (e) {
    console.warn(localStorageUnavailable());
  }
}

function set(e, n) {
  try {
    localStorage.setItem(e, n);
  } catch (e) {
    console.warn(localStorageUnavailable());
  }
}

function clear(e) {
  localStorage.removeItem(e);
}

var store = {
  get: get,
  set: set,
  clear: clear
},
    _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    readyEvent = "ready",
    changeEvent = "change",
    flushInterval = 2e3,
    locationWatcherInterval = 300;

function initialize(e, n) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      t = r.baseUrl || "https://app.launchdarkly.com",
      o = r.eventsUrl || "https://events.launchdarkly.com",
      a = r.streamUrl || "https://clientstream.launchdarkly.com",
      i = r.hash,
      s = void 0 === r.sendEvents || r.sendEvents,
      c = e,
      u = EventEmitter(),
      l = Stream(a, c, i, r.useReport),
      f = EventProcessor(o + "/a/" + c + ".gif", EventSerializer(r)),
      v = Requestor(t, c, r.useReport),
      d = {},
      p = parseInt(r.samplingInterval, 10) || 0,
      g = "object" === _typeof(r.bootstrap) ? transformValuesToVersionedValues(r.bootstrap) : {},
      y = void 0,
      h = void 0,
      m = void 0,
      E = void 0;

  function k(e, n) {
    var r = "";
    return n && (r = i || btoa(JSON.stringify(n))), "ld:" + e + ":" + r;
  }

  function w() {
    return s && !function () {
      var e = void 0;
      e = navigator && void 0 !== navigator.doNotTrack ? navigator.doNotTrack : navigator && void 0 !== navigator.msDoNotTrack ? navigator.msDoNotTrack : window.doNotTrack;
      return "1" === e || "yes" === e;
    }() && (0 === p || 0 === Math.floor(Math.random() * p));
  }

  function b(e) {
    w() && f.enqueue(e);
  }

  var S = Identity(n, function (e) {
    b({
      kind: "identify",
      key: e.key,
      user: e,
      creationDate: new Date().getTime()
    });
  }),
      U = k(c, S.getUser());

  function L(e, n, r) {
    var t = S.getUser(),
        o = JSON.stringify(n) + (t && t.key ? t.key : "") + e,
        a = new Date(),
        i = d[o];
    i && a - i < 3e5 || (d[o] = a, b({
      kind: "feature",
      key: e,
      user: t,
      value: n,
      default: r,
      creationDate: a.getTime()
    }));
  }

  function N(e, n) {
    var r = {
      kind: e,
      key: n.key,
      data: null,
      url: window.location.href,
      user: S.getUser(),
      creationDate: new Date().getTime()
    };
    return "click" === e && (r.selector = n.selector), b(r);
  }

  function T(e, n) {
    var r = void 0;
    return L(e, r = g && g.hasOwnProperty(e) && !g[e].deleted ? null === g[e].value ? n : g[e].value : n, n), r;
  }

  function R() {
    S.getUser() && (l.disconnect(), l.connect(S.getUser(), {
      ping: function ping() {
        v.fetchFlagSettings(S.getUser(), i, function (e, n) {
          e && u.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), O(n);
        });
      },
      put: function put(e) {
        O(JSON.parse(e.data));
      },
      patch: function patch(e) {
        var n = JSON.parse(e.data);

        if (!g[n.key] || g[n.key].version < n.version) {
          var r = {},
              t = g[n.key];
          g[n.key] = {
            version: n.version,
            value: n.value
          }, r[n.key] = t ? {
            previous: t.value,
            current: n.value
          } : {
            current: n.value
          }, F(r);
        }
      },
      delete: function _delete(e) {
        var n = JSON.parse(e.data);

        if (!g[n.key] || g[n.key].version < n.version) {
          var r = {};
          g[n.key] && !g[n.key].deleted && (r[n.key] = {
            previous: g[n.key].value
          }), g[n.key] = {
            version: n.version,
            deleted: !0
          }, F(r);
        }
      }
    }));
  }

  function O(e) {
    var n = {};

    if (e) {
      for (var r in g) {
        g.hasOwnProperty(r) && (e[r] && e[r].value !== g[r].value ? n[r] = {
          previous: g[r].value,
          current: e[r].value
        } : e[r] && !e[r].deleted || (n[r] = {
          previous: g[r].value
        }));
      }

      for (var t in e) {
        !e.hasOwnProperty(t) || g[t] && !g[t].deleted || (n[t] = {
          current: e[t].value
        });
      }

      g = e, F(n);
    }
  }

  function F(e) {
    var n = Object.keys(e);
    h && (store.clear(U), U = k(c, S.getUser()), store.set(U, JSON.stringify(transformValuesToUnversionedValues(g)))), n.length > 0 && (n.forEach(function (n) {
      u.emit(changeEvent + ":" + n, e[n].current, e[n].previous);
    }), u.emit(changeEvent, e), n.forEach(function (n) {
      L(n, e[n].current);
    }));
  }

  if (void 0 !== r.samplingInterval && (isNaN(r.samplingInterval) || r.samplingInterval < 0) && (p = 0, onNextTick(function () {
    u.maybeReportError(new LDInvalidArgumentError("Invalid sampling interval configured. Sampling interval must be an integer >= 0."));
  })), e || onNextTick(function () {
    u.maybeReportError(new LDInvalidEnvironmentIdError(environmentNotSpecified()));
  }), n ? n.key || onNextTick(function () {
    u.maybeReportError(new LDInvalidUserError(invalidUser()));
  }) : onNextTick(function () {
    u.maybeReportError(new LDInvalidUserError(userNotSpecified()));
  }), "object" === _typeof(r.bootstrap)) onNextTick(function () {
    u.emit(readyEvent);
  });else if ("string" == typeof r.bootstrap && "LOCALSTORAGE" === r.bootstrap.toUpperCase() && localStorage) {
    h = !0;

    try {
      g = transformValuesToVersionedValues(JSON.parse(store.get(U)));
    } catch (e) {
      store.clear(U);
    }

    null === g ? v.fetchFlagSettings(S.getUser(), i, function (e, n) {
      e && u.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), g = n, n && store.set(U, JSON.stringify(transformValuesToUnversionedValues(g))), u.emit(readyEvent);
    }) : (onNextTick(function () {
      u.emit(readyEvent);
    }), v.fetchFlagSettings(S.getUser(), i, function (e, n) {
      e && u.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), n && store.set(U, JSON.stringify(transformValuesToUnversionedValues(n)));
    }));
  } else v.fetchFlagSettings(S.getUser(), i, function (e, n) {
    e && u.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), g = n, u.emit(readyEvent);
  });

  function I() {
    y && y.dispose(), m && m.length && (y = GoalTracker(m, N));
  }

  function x() {
    s && setTimeout(function e() {
      f.flush(S.getUser()), setTimeout(e, flushInterval);
    }, flushInterval);
  }

  v.fetchGoals(function (e, n) {
    e && u.maybeReportError(new LDUnexpectedResponseError((e.message, e.message))), n && n.length > 0 && (y = GoalTracker(m = n, N), function (e, n) {
      var r = location.href,
          t = void 0;

      function o() {
        (t = location.href) !== r && (r = t, n());
      }

      !function e(n, r) {
        n(), setTimeout(function () {
          e(n, r);
        }, r);
      }(o, e), window.history && history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(locationWatcherInterval, I));
  }), "complete" !== document.readyState ? window.addEventListener("load", x) : x(), window.addEventListener("beforeunload", function () {
    s && f.flush(S.getUser(), !0);
  }), window.addEventListener("message", function (e) {
    if (e.origin === t && "SYN" === e.data.type) {
      window.editorClientBaseUrl = t;
      var n = document.createElement("script");
      n.type = "text/javascript", n.async = !0, n.src = t + e.data.editorClientUrl;
      var r = document.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(n, r);
    }
  });
  var C = new Promise(function (e) {
    var n = u.on(readyEvent, function () {
      u.off(readyEvent, n), e();
    });
  });
  return {
    waitUntilReady: function waitUntilReady() {
      return C;
    },
    identify: function identify(e, n, r) {
      return wrapPromiseCallback(new Promise(function (r, t) {
        S.setUser(e), v.fetchFlagSettings(S.getUser(), n, function (e, n) {
          if (e) return u.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))), t(e);
          n && O(n), r(n), E && R();
        });
      }), r);
    },
    variation: T,
    track: function track(e, n) {
      "string" == typeof e ? (m && !function (e) {
        if (!m || 0 === m.length) return !1;

        for (var n = 0; n < m.length; n++) {
          if ("custom" === m[n].kind && m[n].key === e) return !0;
        }

        return !1;
      }(e) && console.warn(unknownCustomEventKey(e)), b({
        kind: "custom",
        key: e,
        data: n,
        user: S.getUser(),
        url: window.location.href,
        creationDate: new Date().getTime()
      })) : u.maybeReportError(new LDInvalidEventKeyError(unknownCustomEventKey(e)));
    },
    on: function on(e, n, r) {
      e.substr(0, changeEvent.length) === changeEvent ? (E = !0, l.isConnected() || R(), u.on.apply(u, [e, n, r])) : u.on.apply(u, Array.prototype.slice.call(arguments));
    },
    off: function off(e) {
      e === changeEvent && (E = !0) && (E = !1, l.disconnect()), u.off.apply(u, Array.prototype.slice.call(arguments));
    },
    flush: function flush(e) {
      return wrapPromiseCallback(new Promise(function (e) {
        return s ? e(f.flush(S.getUser())) : e();
      }, e));
    },
    allFlags: function allFlags() {
      var e = {};
      if (!g) return e;

      for (var n in g) {
        g.hasOwnProperty(n) && (e[n] = T(n, null));
      }

      return e;
    }
  };
}

var version = "1.7.4",
    index = {
  initialize: initialize,
  version: version
};
export default index;